import type { VaultEntry, VaultEntryInput, VaultEntryUpdate } from "@akhshy/types";
import { api } from "../lib/api.ts";
import { useResource } from "../lib/useResource.ts";
import { CrudPage } from "../components/organisms/CrudPage.tsx";
import { VaultForm } from "../components/organisms/forms/VaultForm.tsx";
import { Badge } from "../components/atoms/Badge.tsx";
import type { Column } from "../components/organisms/DataTable.tsx";

const columns: Column<VaultEntry>[] = [
  { header: "Title", render: (i) => <span className="cell-title">{i.title}</span> },
  { header: "Kind", render: (i) => <Badge tone="kind">{i.kind}</Badge> },
];

export function VaultPage() {
  const resource = useResource<VaultEntry, VaultEntryInput, VaultEntryUpdate>(api.vault);
  return (
    <CrudPage
      intro="Notes and links that show up in the vault."
      resource={resource}
      columns={columns}
      emptyText="the vault is empty — file something."
      newLabel="New entry"
      formTitle={(editing) => (editing ? "Edit vault entry" : "New vault entry")}
      itemLabel={(i) => i.title}
      renderForm={(p) => <VaultForm {...p} resource={resource} />}
    />
  );
}
